var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicatePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41667 5.83333H5.25V7.58333H3.5V8.75H5.25V10.5H6.41667V8.75H8.16667V7.58333H6.41667V5.83333Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 12.8333H9.33333C9.97675 12.8333 10.5 12.3101 10.5 11.6667V4.66667C10.5 4.02325 9.97675 3.5 9.33333 3.5H2.33333C1.68991 3.5 1.16666 4.02325 1.16666 4.66667V11.6667C1.16666 12.3101 1.68991 12.8333 2.33333 12.8333ZM2.33333 4.66667H9.33333L9.3345 11.6667H2.33333V4.66667Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 1.16667H4.66666V2.33334H11.6667V9.33334H12.8333V2.33334C12.8333 1.68992 12.3101 1.16667 11.6667 1.16667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicatePlus);
export default __webpack_public_path__ + "static/media/Duplicate-Plus.9203c02ef41e381d1bd96dbad7b57327.svg";
export { ForwardRef as ReactComponent };